import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  sections: {
    display: 'flex',
    height: 'max-content',
  },
  zoom: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    minHeight: '70px',
    width: '100%',
    zIndex: 5,
    backgroundColor: theme.palette.background.paper,
    // The strip spans the full width right over the horizontal scrollbar — let
    // mouse events (scrollbar dragging) pass through; only the zoom control
    // itself stays interactive.
    pointerEvents: 'none',
    '& > *': {
      pointerEvents: 'auto',
    },
    // Keep the control clear of the scrollbar track underneath.
    paddingBottom: '16px',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
    },
    '&.hidden': {
      display: 'none',
    },
  },
}));
